/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;


//////////////////
// WEBPACK FOOTER
// ./~/react-dom/lib/ReactDOMFeatureFlags.js
// module id = 704
// module chunks = 168707334958949